const trimTrailingSlash = (value) => value.replace(/\/+$/, '');

export function getFrontendEnvironment() {
  const apiBaseUrl = (process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000').trim();

  if (!apiBaseUrl) {
    throw new Error('VUE_APP_API_BASE_URL must be defined');
  }

  return {
    apiBaseUrl: trimTrailingSlash(apiBaseUrl),
    refreshIntervalMs: Number(process.env.VUE_APP_REFRESH_INTERVAL_MS || 30000),
  };
}
